/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FishbrainLoginResponse
 */
export interface FishbrainLoginResponse {
    /**
     * 
     */
    ok: boolean;
}

/**
 * Check if a given object implements the FishbrainLoginResponse interface.
 */
export function instanceOfFishbrainLoginResponse(value: object): value is FishbrainLoginResponse {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    return true;
}

export function FishbrainLoginResponseFromJSON(json: any): FishbrainLoginResponse {
    return FishbrainLoginResponseFromJSONTyped(json, false);
}

export function FishbrainLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FishbrainLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
    };
}

export function FishbrainLoginResponseToJSON(json: any): FishbrainLoginResponse {
    return FishbrainLoginResponseToJSONTyped(json, false);
}

export function FishbrainLoginResponseToJSONTyped(value?: FishbrainLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
    };
}

